import { render, staticRenderFns } from "./DockerImage.vue?vue&type=template&id=2900516c"
import script from "./DockerImage.vue?vue&type=script&lang=js"
export * from "./DockerImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports